const flavorConfig = require("./flavorConfig." + process.env.FLAVOR)
module.exports = flavorConfig

// (used by back only)
